<template>
  <b-row>
    <b-col>
      <b-row>
        <b-col>
          <h1 class="pc_brand">Rosie</h1>
          <p class="text-center">
            Rosie is a KC Kennel Club registered dark red Miniature Poodle with a Five Generations Enhanced Pedigree
            Bloodline (Champion Line).
          </p>
        </b-col>
      </b-row>
      <b-row>
        <GalleryComponent :slides="rosieSlideshowSlides" height="600" />
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
import GalleryComponent from "@/components/GalleryComponent.vue";
import {mapState} from "vuex";

export default {
  name: 'RosieView',
  components: {GalleryComponent},
  computed: mapState([
    'rosieSlideshowSlides',
  ]),
  mounted() {
    this.$store.dispatch('createRosieSlideshowSlides');
  }
}
</script>
